import { createSlice } from '@reduxjs/toolkit';
import { MedicalSearchRequest, t_medical_institution } from 'types';
import { getListMedical } from './thunk';

interface InitialState {
  items: t_medical_institution[];
  totalItems: number;
  currentPage: number;
  searchValue: MedicalSearchRequest;
}

const initialState: InitialState = {
  items: [],
  totalItems: 0,
  currentPage: 1,
  searchValue: {
    address: '',
    facility_name: '',
    code: '',
    phone: '',
  },
};

const medicalSlices = createSlice({
  name: 'medicals',
  initialState,
  reducers: {
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    resetSearchValue(state) {
      state.searchValue = {
        address: '',
        code: '',
        facility_name: '',
        phone: '',
      };
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListMedical.fulfilled, (state, action) => {
      return { ...state, ...action.payload };
    });
  },
});

export const { setSearchValue, setCurrentPage, resetSearchValue } = medicalSlices.actions;
export default medicalSlices.reducer;
